// store/modules/planning.js
const state = {
  planningData: null,
  planningDataLoading: false,
  planningWasCreated: false
}

const mutations = {
  setPlanningData (state, payload) {
    state.planningData = payload
  },
  setPlanningDataLoading (state, isLoading) {
    state.planningDataLoading = isLoading
  },
  setPlanningWasCreated (state, status) {
    state.planningWasCreated = status
  }
}

const actions = {
  planningLoadData ({ commit }) {
    commit('setPlanningData', Math.floor(Math.random() * 100))
  },
  async togglePlanningLoading ({ commit }, isLoading) {
    commit('setPlanningDataLoading', isLoading)
  },
  markPlanningCreated ({ commit }) {
    commit('setPlanningWasCreated', true)
  },
  clearPlanningCreated ({ commit }) {
    commit('setPlanningWasCreated', false)
  }
}

const getters = {
  getPlanningData (state) {
    return state.planningData
  },
  isPlanningLoading (state) {
    return state.planningDataLoading
  },
  wasPlanningCreated (state) {
    return state.planningWasCreated
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
